import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import { obtenerArchivos } from "../AccionesBackend";
import "react-multi-carousel/lib/styles.css";

export const CarouselNews = ({ seccionId }) => {
    const [carouselImages, setCarouselImages] = useState([]);

    useEffect(() => {
        // Se obtienen los archivos según el seccionId
        obtenerArchivos({ seccionId })
            .then((result) => {
                if (result && result.success) {
                    setCarouselImages(
                        result.archivos.map((pdf) => ({
                            alt: pdf.nombre_archivo,
                            src: pdf.ruta_archivo,
                        }))
                    );
                } else {
                    console.error(result.mensaje);
                }
            })
            .catch((error) => {
                console.error("Error al obtener los archivos:", error);
            });
    }, [seccionId]);

    const responsive = {
        allDevices: { breakpoint: { max: 4000, min: 0 }, items: 1 },
    };

    return (
        <section className="carousel" id="carousels">
            <Container>
                <Row>
                    <Col>
                        {carouselImages.length > 0 ? (
                            <Carousel
                                className="carousel-slider"
                                swipeable={true}
                                draggable={true}
                                showDots={true}
                                responsive={responsive}
                                ssr={true}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={4000}
                                keyBoardControl={true}
                                customTransition="all 0.5s ease"
                                transitionDuration={500}
                                containerClass="carousel-container"
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                dotListClass="custom-dot-list-style"
                                itemClass="carousel-item-padding-40-px"
                            >
                                {carouselImages.map((image, index) => (
                                    <div key={index} className="item">
                                            <img
                                                src={image.src}
                                                alt={image.alt || `Image ${index + 1}`}
                                                className="carousel-image"
                                            />
                                    </div>
                                ))}
                            </Carousel>
                        ) : (
                            <div className="carousel-error-message">
                                <p style={{ fontSize: "1.5rem" }}>
                                    No hay imágenes disponibles en el carrusel.
                                </p>
                            </div>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
